import { validatePhoneNumber } from '../../lib/funnels/functions/v1/formats/validatePhoneNumber.js'
import { showInputError } from '../../lib/funnels/functions/v1/html/showInputError.js'
import { hideInputError } from '../../lib/funnels/functions/v1/html/hideInputError.js'
import { setUpFormInputs } from '../../lib/funnels/functions/v1/html/setupFormInputs.js'

// Wait for DOM to be ready
document.addEventListener('DOMContentLoaded', function () {
  // Set up form inputs (phone mask, validation, etc.)
  setUpFormInputs()

  const form = document.getElementById('verify-form')

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault()

      // Get form elements
      const firstNameElement = /** @type {HTMLInputElement} */ (
        document.getElementById('firstName')
      )
      const lastNameElement = /** @type {HTMLInputElement} */ (
        document.getElementById('lastName')
      )
      const phoneElement = /** @type {HTMLInputElement} */ (
        document.getElementById('phone')
      )
      const smsConsentElement = /** @type {HTMLInputElement} */ (
        document.getElementById('smsConsent')
      )
      const termsConsentElement = /** @type {HTMLInputElement} */ (
        document.getElementById('termsConsent')
      )

      let hasErrors = false

      // Validate First Name
      if (!firstNameElement?.value.trim()) {
        if (firstNameElement) {
          firstNameElement.setAttribute(
            'data-error-message',
            'Please enter your first name',
          )
          showInputError(firstNameElement)
          hasErrors = true
        }
      } else if (firstNameElement) {
        hideInputError(firstNameElement)
      }

      // Validate Last Name
      if (!lastNameElement?.value.trim()) {
        if (lastNameElement) {
          lastNameElement.setAttribute(
            'data-error-message',
            'Please enter your last name',
          )
          showInputError(lastNameElement)
          hasErrors = true
        }
      } else if (lastNameElement) {
        hideInputError(lastNameElement)
      }

      // Validate Phone
      if (!phoneElement?.value.trim()) {
        if (phoneElement) {
          phoneElement.setAttribute(
            'data-error-message',
            'Phone number is required',
          )
          showInputError(phoneElement)
          hasErrors = true
        }
      } else if (phoneElement && !validatePhoneNumber(phoneElement.value)) {
        phoneElement.setAttribute(
          'data-error-message',
          'Please enter a valid phone number',
        )
        showInputError(phoneElement)
        hasErrors = true
      } else if (phoneElement) {
        hideInputError(phoneElement)
      }

      // Validate SMS Consent
      if (!smsConsentElement?.checked) {
        if (smsConsentElement) {
          // For checkboxes, we'll show error differently since they don't have nextElementSibling
          alert('You must consent to SMS terms to continue')
          hasErrors = true
        }
      }

      // Validate Terms Consent
      if (!termsConsentElement?.checked) {
        if (termsConsentElement) {
          alert('You must agree to the terms of service and privacy policy')
          hasErrors = true
        }
      }

      // If no errors, proceed with success
      if (!hasErrors) {
        // Hide the form
        const formContainer = document.getElementById('verify-form-container')
        const successMessage = document.getElementById('success-message')

        if (formContainer) {
          formContainer.style.display = 'none'
        }

        if (successMessage) {
          successMessage.style.display = 'block'
        }
      }
    })
  }
})
